import { DatePipe } from '@angular/common';
import { Component, forwardRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BusinessService } from '@app/business/business.service';
import { selectorAuth, SessionStorageService } from '@app/core';
import { InfoService } from '@app/core/info/info.service';
import { IUserData } from '@app/profile/main/details';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cloud-business-identification',
  templateUrl: './business-identification.component.html',
  styleUrls: ['./business-identification.component.scss']
})
export class BusinessIdentificationComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  identificatorForm: FormGroup;
  status = [];
  readonly displayedColumns = [
    'status',
    'registrationTime',
    'clientIdentifierType',
    'clientIdentifier',
    'name',
    'email',
    'phone',
    'actions'
  ];

  idintificatorDataSource = new MatTableDataSource<any>([]);
  loading = false;
  order: string = 'ASC';
  orderByFilter: string = 'PHONE';
  offsetValue: number = 0;
  limitPage: number = 10;
  // hasPaging: boolean = true;
  isLoading = true
  userData: IUserData;
  companyCmrId: any;
  totalCountPages: any;

  callbackId: any;
  dataFilterMaxRange = 7;

  @Input() active: boolean;
  @ViewChild(MatSort) sort!: MatSort;

  websessionId: any;
  signsessionId: any;
  idResult: any;
  businessAccountId: any;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private store: Store<any>,
    private sessionStorageService: SessionStorageService,
    private businessService: BusinessService,
    public info: InfoService,
  ) { }

  ngOnInit(): void {
    this.store
      .select(selectorAuth)
      .subscribe(auth => {
        if (auth != null) {
          this.userData = auth.userData;
        }
        if (this.userData == undefined) {
          this.userData = this.sessionStorageService.getItem("loginEventData")
        }
      });
    this.companyCmrId = this.sessionStorageService.getItem("businessAccountId");

    this.buildForm()
    this.loadCertificates()
  }
  ngAfterViewInit() {
    this.idintificatorDataSource.sort = this.sort;

    setTimeout(() => {
      this.sort.active = 'registrationTime';
      this.sort.direction = 'desc';
      this.sort.sortChange.emit();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['active']?.currentValue) {
      this.loadCertificates();
    }
  }
  get lang() {
    return this.translateService.currentLang;
  }
  getName(e) {
    if (e !== null) {
      return this.lang === 'bg' ? e.bg : e.en;
    } else {
      return '';
    }

  }

  buildForm() {
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 1);

    const startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - this.dataFilterMaxRange);

    this.identificatorForm = this.formBuilder.group({
      startDate: new FormControl(startDate),
      endDate: new FormControl(endDate),
      name: new FormControl(''),
      identificator: new FormControl('', [Validators.pattern(/^[0-9]{10}$/)]),
      email: new FormControl('', [Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]),
      phone: new FormControl('', [Validators.pattern(/^(?!\+?3590)(?!\+0)(\+[0-9]{7,15})$/)]),

    }, { validators: this.dateRangeValidator(this.dataFilterMaxRange) });

    this.identificatorForm.get('startDate')?.valueChanges.subscribe(() => this.updateIdentificatorValidation());
    this.identificatorForm.get('endDate')?.valueChanges.subscribe(endDate => {
      const startControl = this.identificatorForm.get('startDate');
      if (endDate && !startControl?.value) {
        const from = new Date(endDate);
        from.setDate(from.getDate() - this.dataFilterMaxRange);
        startControl.setValue(from, { emitEvent: true });
      } else {
        this.updateIdentificatorValidation();
      }
    });
  }

  isFormEmpty(): boolean {
    const formValues = this.identificatorForm.value;
    return Object.values(formValues).every(value => value === null || value === '');
  }
/* Merge Conflicts BT-1949
  dateRangeValidator(group: AbstractControl): ValidationErrors | null {
    const fromDate = group.get('fromStartDate')?.value;
    const toDate = group.get('toStartDate')?.value;
  
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      const diffInDays = (to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24);
  
      return diffInDays >= 7 ? null : { dateInvalid: true };
    }
    return null;
  }
  updateIdentificatorValidation() {
    const fromStartDate = this.identificatorForm.get('fromStartDate')?.value;
    const toStartDate = this.identificatorForm.get('toStartDate')?.value;
  
    if (fromStartDate && toStartDate) {
      this.identificatorForm.get('identificator')?.clearValidators();
    } else {
      this.identificatorForm.get('identificator')?.setValidators([Validators.required, Validators.minLength(6)]);
    }
    this.identificatorForm.get('identificator')?.updateValueAndValidity();
  }
  limitToSevenDays = (date: Date | null): boolean => {
    if (!date) return false;
    
    const fromDate = this.identificatorForm.get('fromStartDate')?.value;
    if (!fromDate) return true;
  
    const minDate = new Date(fromDate);
    const maxDate = new Date(fromDate);
    maxDate.setDate(maxDate.getDate() + 7); 
  
    return date >= minDate && date <= maxDate; 
  };
  
  toggleIdentificatorValidation() {
    const fromDate = this.identificatorForm.get('fromStartDate')?.value;
    const toDate = this.identificatorForm.get('toStartDate')?.value;
    const identificatorControl = this.identificatorForm.get('identificator');
  
    if (fromDate && toDate) {
      identificatorControl?.clearValidators(); 
    } else {
      identificatorControl?.setValidators([Validators.required]);
    }
  
    identificatorControl?.updateValueAndValidity();
  }
  shouldShowIdentificatorError(): boolean {
    const identificator = this.identificatorForm.get('identificator');
    const fromDate = this.identificatorForm.get('fromStartDate')?.value;
    const toDate = this.identificatorForm.get('toStartDate')?.value;
  
    const datesNotSelected = !fromDate || !toDate;
    const formTouched = this.identificatorForm.touched || this.identificatorForm.dirty;
    const identificatorTouchedOrDirty = identificator?.touched || identificator?.dirty;
  
    return identificator?.hasError('required') &&
           (identificatorTouchedOrDirty || formTouched) &&
           datesNotSelected;
  }
  
  
  loadCertificates() {
    const datePipe = new DatePipe('en-US');
    const formValues = this.identificatorForm.value;


    Object.keys(formValues).forEach((key) => {
      if (formValues[key]) {
        if (['fromStartDate', 'toStartDate'].includes(key)) {
          formValues[key] = datePipe.transform(formValues[key], 'dd.MM.yyyy');
        } else {
          formValues[key] = formValues[key];
        }
      }
    });
    const searchCriteria = {
      ...formValues
    };
    this.businessService.getHistoryIdentificationTab(searchCriteria, this.companyCmrId).subscribe((response: any) => {
      this.idintificatorDataSource = new MatTableDataSource(response.body?.data);
     
    })

    this.isLoading = false;

  }*/

  isFormValid(): boolean {
    return this.identificatorForm.valid;
  }

  dateRangeValidator(dataFilterMaxRange: number): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const fromDate = group.get('startDate')?.value;
      const toDate = group.get('endDate')?.value;

      if (fromDate && !toDate || !fromDate && toDate) {
        return { dateInvalid: true };
      } else if (fromDate && toDate) {
        const diffInDays = (new Date(toDate).getTime() - new Date(fromDate).getTime()) / (1000 * 60 * 60 * 24);
        return diffInDays <= dataFilterMaxRange ? null : { dateInvalid: true };
      }
      return null;
    }
  }

  updateIdentificatorValidation() {
    const startDate = this.identificatorForm.get('startDate')?.value;
    const endDate = this.identificatorForm.get('endDate')?.value;
    const identificatorControl = this.identificatorForm.get('identificator');

    let isDateValid = false;
    if (startDate && endDate) {
      const diffInDays = (new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24);
      isDateValid = diffInDays <= this.dataFilterMaxRange;
    }

    if ((startDate && endDate && isDateValid)) {
      identificatorControl?.clearValidators();
    } else {
      identificatorControl?.setValidators([Validators.required, Validators.pattern(/^[0-9]{10}$/)]);
    }
    identificatorControl?.updateValueAndValidity();
  }

  filterStartDate = (date: Date | null): boolean => {
    if (!date) return false;
    const endDate = this.identificatorForm.get('endDate')?.value;
    if (!endDate) return true;
    const maxDate = new Date(endDate);
    const minDate = new Date(endDate);
    minDate.setDate(maxDate.getDate() - this.dataFilterMaxRange);
    return date >= minDate && date <= maxDate;
  }

  filterEndDate = (date: Date | null): boolean => {
    if (!date) return false;
    const startDate = this.identificatorForm.get('startDate')?.value;
    if (!startDate) return true;
    const minDate = new Date(startDate);
    const maxDate = new Date(startDate);
    maxDate.setDate(minDate.getDate() + this.dataFilterMaxRange);
    return date >= minDate && date <= maxDate;
  }

  shouldShowIdentificatorError(): boolean {
    const identificator = this.identificatorForm.get('identificator');
    const fromDate = this.identificatorForm.get('startDate')?.value;
    const toDate = this.identificatorForm.get('endDate')?.value;

    if (fromDate || toDate) {
      return false;
    }

    if (identificator?.value && identificator.value.trim()) {
      return false;
    }

    const formInteracted = identificator?.touched ||
      identificator?.dirty ||
      this.identificatorForm.touched ||
      this.identificatorForm.dirty;

    return identificator?.hasError('required') || formInteracted;
  }
  loadCertificates() {
    const datePipe = new DatePipe('en-US');
    const formValues = this.identificatorForm.value;
    const processedValues = new Map();

    Object.keys(formValues).forEach((key) => {
      const value = formValues[key];

      if (['startDate', 'endDate'].includes(key)) {
        if (value) {
          const date = new Date(value);
          if (!isNaN(date.getTime())) {
            processedValues.set(key, datePipe.transform(date, 'dd.MM.yyyy'));
          } else {
            processedValues.set(key, '');
          }
        } else {
          processedValues.set(key, formValues[key]);
        }
      } else {
        processedValues.set(key, value);
      }
    });

    const searchCriteria = {
      offset: this.offsetValue,
      limit: this.limitPage,
      ...Object.fromEntries(processedValues)
    };
    if (searchCriteria.phone) {
      try {
        if (searchCriteria.phone.includes('%')) {
          searchCriteria.phone = decodeURIComponent(searchCriteria.phone);
        }
      } catch (error) {
        console.warn('Failed to decode phone number:', error);
      }
    }
    this.businessService.getHistoryIdentificationTab(searchCriteria, this.companyCmrId).subscribe((response: any) => {
      this.idintificatorDataSource.data = response.body?.data ?? [];
      this.isLoading = false;
    })
  }

  hasData(): boolean {
    return (this.idintificatorDataSource && this.idintificatorDataSource.data.length !== 0);
  }

  onPaginateChange(event: PageEvent) {
    this.offsetValue = event.pageIndex
    this.limitPage = event.pageSize;
    this.loadCertificates();
  }
/* Merge conflicts BT-1949
  clearField(field: string) {
    const control = this.identificatorForm.get(field);
  if (control) {
    control.setValue(null);
    control.markAsPristine();
    control.markAsUntouched(); 
    control.updateValueAndValidity();

    if (field !== 'fromStartDate' && field !== 'toStartDate') {
      this.loadCertificates();
    }
 
    }
  }

  downloadUEI(callbackId: any){
    console.log('callbackId',callbackId)
    this.callbackId = callbackId
    this.businessService.getDownloadUEI(this.companyCmrId,this.callbackId).subscribe((res: any)=> {
      */

  clearField(field: string) {
    const control = this.identificatorForm.get(field);
    if (control) {
      control.setValue('');
      control.markAsPristine();
      control.markAsUntouched();
      control.updateValueAndValidity();

      if (field !== 'startDate' && field !== 'endDate') {
        this.loadCertificates();
      }

    }
  }
  resetFilters() {
    const startDate = this.identificatorForm.get('startDate')?.value;
    const endDate = this.identificatorForm.get('endDate')?.value;

    this.identificatorForm.reset({
      phone: '',
      email: '',
      identificator: '',
      name: '',
      startDate,
      endDate
    }, { emitEvent: false });
  }

  onEnter(event: KeyboardEvent) {
    event.preventDefault();
    if (this.identificatorForm.valid) {
      this.loadCertificates();
    }
  }

  downloadUEI(callbackId: string, clientIdentifier: string) {
    this.callbackId = callbackId
    this.businessService.getDownloadUEI(this.companyCmrId, this.callbackId).subscribe((res: any) => {
      if (res?.code === 'OK' && res?.data?.content) {
        const byteCharacters = atob(res.data.content);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `UEI_${clientIdentifier}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    }, (error) => {
      console.error('Download error', error);

    })
  }

  exportExcel() {
    if (!this.hasData()) {
      this.info.error(this.translateService.instant('certificates.noDataExport'));
      return;
    }
    const formValues = { ...this.identificatorForm.value };
    const datePipe = new DatePipe('en-US');
    const processedValues = new Map();

    Object.keys(formValues).forEach((key) => {
      if (formValues[key]) {
        if (['startDate', 'endDate'].includes(key)) {
          if (formValues[key] instanceof Date) {
            let date: Date = formValues[key];
            processedValues.set(key, datePipe.transform(date, 'dd.MM.yyyy'));
          }
        }
      } else {
        processedValues.set(key, formValues[key]);
      }
    });
    const searchCriteria = {
      ...Object.fromEntries(processedValues)
    };
    this.businessService.getIdentificationInExcelFormat(searchCriteria, this.companyCmrId)
      .subscribe({
        next: (response) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          const matches = /filename="?([^";]+)"?/i.exec(contentDisposition || '');
          const fileName = (matches && matches[1]) ? matches[1].trim() : 'Portal_Report.xlsx';

          const blob = new Blob([response.body], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        error: () => {
          this.info.error(this.translateService.instant('general.downloadError'));
        }
      });
  }
}
